import { defineMessages } from 'react-intl';

export default defineMessages({
    TotalPrice: {
        id: 'quoteandbind.common.sgPaymentHeader.TotalPrice',
        defaultMessage: 'Total price: '
    },
    CardSinglePayment: {
        id: 'quoteandbind.common.sgPaymentHeader.CardSinglePayment',
        defaultMessage: 'We require a single one off credit/debit card payment for your insurance policy.'
    },
    DoNotRefresh: {
        id: 'quoteandbind.common.sgPaymentHeader.DoNotRefresh',
        defaultMessage: 'Please don’t refresh or navigate away from this page.'
    },
    PleaseNote: {
        id: 'quoteandbind.common.sgPaymentHeader.PleaseNote',
        defaultMessage: 'Please note: '
    },
    FirstDirectDebit: {
        id: 'quoteandbind.common.sgPaymentHeader.FirstDirectDebit',
        defaultMessage: 'Your first Direct Debit payment of '
    },
    FollowedByInstallments: {
        id: 'quoteandbind.common.sgPaymentHeader.FollowedByInstallments',
        defaultMessage: 'Followed by - {numberOfInstallmentLeft} monthly Direct Debit payments of '
    },
    FollowedByQuarterlyInstallments: {
        id: 'quoteandbind.common.sgPaymentHeader.FollowedByQuarterlyInstallments',
        defaultMessage: 'Followed by - {numberOfInstallmentLeft} quarterly Direct Debit payments of '
    },
    FirstDirectDebitMixed: {
        id: 'quoteandbind.common.sgPaymentHeader.FirstDirectDebitMixed',
        defaultMessage: 'Step 1: Your first Direct Debit payment of '
    },
    MixedStepTwo: {
        id: 'quoteandbind.common.sgPaymentHeader.MixedStepTwo',
        defaultMessage: 'Step 2: Pay your deposit '
    },
    CreditDebitCardPayment: {
        id: 'quoteandbind.common.sgPaymentHeader.CreditDebitCardPayment',
        defaultMessage: 'Credit/Debit card payment'
    },
    AnnualDirectDebitPayment: {
        id: 'quoteandbind.common.sgPaymentHeader.AnnualDirectDebitPayment',
        defaultMessage: 'Annual Direct Debit payment'
    },
    YourPayment: {
        id: 'quoteandbind.common.sgPaymentHeader.YourPayment',
        defaultMessage: 'Your payment is secure'
    },
    InformationProtected: {
        id: 'quoteandbind.common.sgPaymentHeader.InformationProtected',
        defaultMessage: 'To ensure your information is protected we encrypt all your personal details.'
    }
});
